
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  data() {
    return {
      activeTab: null,
    };
  },
  methods: {
    clearLocalStorage() {
      localStorage.clear();
      location.reload();
    },
  },
});
